import { cx } from "../common/cx";
import type { TargetRect } from "./useTargetRect";
import styles from "./TutorialOverlay.module.css";

interface SpotlightProps {
  rect: TargetRect | null;
  padding: number;
  dimActive: boolean;
}

/** Dims the screen around `rect`; with no rect the whole screen is dimmed. */
export function Spotlight({ rect, padding, dimActive }: SpotlightProps): JSX.Element {
  if (!rect) {
    return <div className={cx(styles.fullBackdrop, !dimActive && styles.dimFaded)} />;
  }
  const padded = {
    top: Math.max(0, rect.top - padding),
    left: Math.max(0, rect.left - padding),
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
  const panel = cx(styles.panel, !dimActive && styles.dimFaded);
  return (
    <>
      <div className={panel} style={{ top: 0, left: 0, right: 0, height: padded.top }} />
      <div
        className={panel}
        style={{ top: padded.top + padded.height, left: 0, right: 0, bottom: 0 }}
      />
      <div
        className={panel}
        style={{ top: padded.top, left: 0, width: padded.left, height: padded.height }}
      />
      <div
        className={panel}
        style={{
          top: padded.top,
          left: padded.left + padded.width,
          right: 0,
          height: padded.height,
        }}
      />
      <div
        className={cx(styles.spotlight, dimActive && styles.spotlightFlash)}
        style={{
          top: padded.top,
          left: padded.left,
          width: padded.width,
          height: padded.height,
        }}
      />
    </>
  );
}
